<script setup lang="ts">
import { QItem } from "quasar";
import { DrawerUrlOptions } from "../../../store/drawers";
import { usePermission } from "../../../composables/permission";
import MTooltipBasic from "../MTooltipBasic";
import { useRouter } from "vue-router";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    // TODO add type name
    to?: string | { url: string; name?: string; method?: string } | { name: string };
    permission?: string | true | "true" | { url: string; method?: string };

    toModal?: string | DrawerUrlOptions | object | false;
    toSlideover?: string | DrawerUrlOptions | object | false;

    disable?: boolean;
    disabled?: boolean;

    click?: (...args: any[]) => PromiseLike<any> | void;
    onClick?: (...args: any[]) => PromiseLike<any> | void;

    noClickable?: boolean;

    disabledTooltip?: string;
  }>(),
  {
    disabledTooltip: undefined,
  },
);

const { hasAccess, disabled, onClick } = usePermission(props, false, useRouter());
</script>
<template>
  <q-item
    class="m-item"
    v-bind="$attrs"
    :to="to"
    :disable="disabled"
    :aria-disabled="disabled"
    :clickable="!noClickable && !disabled"
    @click="onClick"
  >
    <MTooltipBasic v-if="$props.disable || $props.disabled">{{ disabledTooltip }}</MTooltipBasic>
    <MTooltipBasic v-else-if="!hasAccess">
      You don’t have permission to perform this action.
    </MTooltipBasic>
    <slot />
  </q-item>
</template>

<style></style>
